<template>
  <component :is="comp" :noteUsage="noteUsage" :kanbanView="isKanbanView" @noteViewChange="noteViewChange"></component>
</template>

<script setup>
import Notes from "./Notes.vue";
import Kanban from "@/views/NotesKanban/Kanban.vue";
import { QueryManager, NoteViews, Operators, SupportedTypes } from "Modules/NotesQueryManager.js";
import { GetSubscription } from "Services/SubscriptionService";
import MixpanelService from "Services/MixpanelService";
import { ref, shallowRef, getCurrentInstance } from "vue";
import { useStore } from 'vuex';
const store = useStore();

let view = store.getters.getNotesView;
let tmp = Notes;
let viewBool = view === 'kanban';
if (viewBool) {
  tmp = Kanban;
}

const isKanbanView = ref(viewBool);
let comp = shallowRef(tmp);

function noteViewChange (view) {
  localStorage.setItem("notesView", view);
  store.commit("set_notes_view", view);
  switch (view) {
    case ('kanban'): isKanbanView.value = true;
      comp = shallowRef(Kanban); break;
    case ('table'):
    default: isKanbanView.value = false;
      comp = shallowRef(Notes);
  }
  logViewChange(view);
}
function logViewChange (view) {
  let subId = store.getters.getSubscriptionId;
  MixpanelService.Track("AdminPortal:NotesListSelection", {
    subscription_id: subId,
    view: view,
  });
  MixpanelService.Engage({
    preferredNotesList: view,
  });
}
function isUserScribe () {
  if (!store.getters.getUserGroups) return false;
  return store.getters.getUserGroups.findIndex(x => x === "Scribe") !== -1;
}
function isUserVerified () {
  return store.getters.getUserPerms.verified;
}
let noteUsage = ref({}).value;
if (isUserScribe() || isUserVerified()) {
  GetSubscription()
    .then(resp => {
      if (!resp.data.payment_profile) return;
      let nextBillingDate = new Date(resp.data.payment_profile.next_billing_at);
      let lastBillingDate = new Date(resp.data.payment_profile.next_billing_at);
      lastBillingDate.setMonth(lastBillingDate.getMonth() - 1);
      noteUsage.start = Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric", }).format(lastBillingDate.getTime());
      noteUsage.end = Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric", }).format(nextBillingDate.getTime());
      new QueryManager({ paged: true, pageSize: 1 }).getNotesWith({
        filters: [{ field: "date_filter", value: [parseInt(lastBillingDate.getTime() / 1000), parseInt(nextBillingDate.getTime() / 1000)], op: Operators.BT, type: SupportedTypes.INT }],
        // sorting: ,
        page: 1,
        NoteView: NoteViews.ALL,
      }).then(x => {
        noteUsage.notesUsedInPeriod = x.data.total_count;
      });
    });
}
</script>
